import { render, staticRenderFns } from "./icon-error.vue?vue&type=template&id=7dcce3be&scoped=true"
import script from "./icon-error.vue?vue&type=script&lang=ts"
export * from "./icon-error.vue?vue&type=script&lang=ts"
import style0 from "./icon-error.vue?vue&type=style&index=0&id=7dcce3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcce3be",
  null
  
)

export default component.exports